import React, { useState } from 'react';
import logo from '../Asset/logo/LOGO LSL-SANS FOND-HD.png'; 
import { Link } from 'react-router-dom';
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { Transition } from '@headlessui/react';
import '../Components/index.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="top-0 left-0 w-full py-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6">

        {/* Logo */}
        <Link to="/">
          <img
            src={logo}
            alt="LE STUDIO LED"
            className="h-[80px] md:h-[120px] xl:h-[150px]"
          />
        </Link>

        {/* Navigation - responsive avec Tailwind uniquement */}
        <div className="hidden xl:flex flex-1 justify-center ml-12">
          <ul className="flex space-x-12 text-lg text-black font-sans font-semibold">
            <li className="hover:text-yellow-500 transition duration-300">
              <Link to="/NotreMission">Notre Mission</Link>
            </li>
            <li className="hover:text-yellow-500 transition duration-300">
              <Link to="/Nossecteurs">Nos secteurs</Link>
            </li>
            <li className="hover:text-yellow-500 transition duration-300">
              <Link to="/NousDécouvrir">Nous Découvrir</Link>
            </li>
            <li className="hover:text-yellow-500 transition duration-300">
              <Link to="/blog">Blog</Link>
            </li>
          </ul>
        </div>

        {/* Contact Button */}
        <div className="hidden xl:flex items-center">
          <Link
            to="/contact"
            className="flex items-center bg-gradient-to-r from-lsl-jaune to-lsl-orange text-black font-medium px-6 py-2 rounded-lg hover:from-yellow-400 hover:to-orange-500 transition duration-300"
          >
            <TfiHeadphoneAlt className="text-2xl" />
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <div className="xl:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-black focus:outline-none"
          >
            {!isOpen ? (
              <svg className="h-6 w-6" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            ) : (
              <svg className="h-6 w-6" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12" />
              </svg>
            )}
          </button>
        </div>

      </div>

      {/* Mobile Menu */}
      <Transition
        show={isOpen}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <div className="xl:hidden bg-white shadow-md py-4 font-sans font-normal">
          <ul className="px-4 space-y-3 text-lg font-medium">
            <li className="hover:text-yellow-500 transition duration-300">
              <Link to="/NotreMission">Notre Mission</Link>
            </li>
            <li className="hover:text-yellow-500 transition duration-300">
              <Link to="/Nossecteurs">Nos secteurs</Link>
            </li>
            <li className="hover:text-yellow-500 transition duration-300">
              <Link to="/NousDécouvrir">Nous Découvrir</Link>
            </li>
            <li className="hover:text-yellow-500 transition duration-300">
              <Link to="/blog">Blog</Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="block bg-gradient-to-r from-lsl-jaune to-lsl-orange  text-black font-medium py-2 px-4 rounded-lg border border-black hover:bg-yellow-500 transition duration-300"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </Transition>
    </nav>
  );
};

export default Navbar;
